
import { createSlice } from "@reduxjs/toolkit";

import { fetchAgents, fetchCategories, fetchClient, fetchCountries, fetchDocumentTypes, fetchEmployee, fetchProjectLists, fetchSubcon, fetchVendor, fetchType } from "../action/commonAction";

const initialState = {
  loading: false,
  error: null,
  clientList: null,
  categoriesList: null,
  agentList: null,
  sourceEnquiryList: null,
  employeeList: null,
  countryList: null,
  ProjectList: null,
  subconList: [],
  vendorList: [],
  dynamicData: {},
  documentTypes: {},
  VendorEntityType: [{ id: "Subcon", title: "Subcon" }, { id: "Vendor", title: "Vendor" }]
};

const commonModuleSlice = createSlice({
  name: "commonModule",
  initialState,
  reducers: {
    clearcommonModule: (state) => {
      state.permissions = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClient.fulfilled, (state, action) => {
        state.loading = false;
        state.clientList = action.payload;
        state.error = null;
      })
      .addCase(fetchClient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categoriesList = action.payload;
        state.error = null;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchAgents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAgents.fulfilled, (state, action) => {
        state.loading = false;
        state.agentList = action.payload;
        state.error = null;
      })
      .addCase(fetchAgents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchType.fulfilled, (state, action) => {
        const { key, data } = action.payload;
        state.loading = false;

        state.dynamicData = {
          ...state.dynamicData,
          [key]: data,
        };


        state.error = null;
      })
      .addCase(fetchType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(fetchEmployee.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployee.fulfilled, (state, action) => {
        state.loading = false;
        state.employeeList = action.payload;
        state.error = null;
      })
      .addCase(fetchEmployee.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(fetchCountries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCountries.fulfilled, (state, action) => {
        state.loading = false;
        state.countryList = action.payload;
        state.error = null;
      })
      .addCase(fetchCountries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(fetchDocumentTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDocumentTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.documentTypes = action.payload;
        state.error = null;
      })
      .addCase(fetchDocumentTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchSubcon.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubcon.fulfilled, (state, action) => {
        state.loading = false;
        state.subconList = action.payload;
        state.error = null;
      })
      .addCase(fetchSubcon.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      .addCase(fetchVendor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendor.fulfilled, (state, action) => {
        state.loading = false;
        state.vendorList = action.payload;
        state.error = null;
      })
      .addCase(fetchVendor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })




      .addCase(fetchProjectLists.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectLists.fulfilled, (state, action) => {
        state.loading = false;
        state.ProjectList = action.payload;
        state.error = null;
      })
      .addCase(fetchProjectLists.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });





  },
});

export const { clearcommonModule } = commonModuleSlice.actions;
export default commonModuleSlice.reducer;